import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { connect } from '../actions/atorch';
export default reducerWithInitialState(null).case(connect.async.done, (state, payload) => payload.result);
